import { BaseApiService } from '@/services/base-service';
import { Reports } from '@/modules/reports/types';
import { ReportOrderTypes } from '@/enums';

export class ReportsService extends BaseApiService {
  private readonly base_path = 'reports';

  async get_orders_reports(filters: Reports.OrdersRequest): Promise<Reports.Orders> {
    const url = `${this.base_path}/orders`;
    const payload = filters;

    const { data } = await this.http_client.get<Reports.Orders>(url, {
      params: {
        filters: payload.filters,
        filters_exist: payload.filters_exist,
        total_exist: payload.total_exist,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_reports_dates(): Promise<Reports.RepairsDates> {
    const url = 'partner/service/order-side/repairs/dates';
    const { data } = await this.http_client.get<Reports.RepairsDates>(url);

    return data;
  }

  async get_repairs_reports(params: Reports.RepairsPayload): Promise<Reports.Repairs> {
    const url = 'partner/service/order-side/repairs';
    const { data } = await this.http_client.get<Reports.Repairs>(url, {
      params,
    });

    return data;
  }

  async get_sales_reports(payload: Reports.PlanFactRequest): Promise<Reports.PlanFactSales> {
    const url = `${this.base_path}/plan-fact`;

    const { data } = await this.http_client.get<Reports.PlanFactSales>(url, {
      params: {
        filters: payload.filters,
        filters_exist: payload.filters_exist,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_money_plan_fact_reports(payload: Reports.PlanFactRequest): Promise<Reports.PlanFactSales> {
    const url = `${this.base_path}/money-plan-fact`;

    const { data } = await this.http_client.get<Reports.PlanFactSales>(url, {
      params: {
        filters: payload.filters,
        filters_exist: payload.filters_exist,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_service_reports(filters: any, is_download: boolean): Promise<Reports.ServiceActivities> {
    const url = `${this.base_path}/results-service-activities`;
    const payload = filters;

    const { data } = await this.http_client.get<Reports.ServiceActivities>(url, {
      params: {
        is_download,
        filters: payload.filters,
        filters_exist: payload.filters_exist,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_mutuals_reports(filters: Reports.MutualRequest, is_download: boolean): Promise<Reports.Mutuals> {
    const url = `${this.base_path}/mutual-payment`;
    const payload = filters;

    const { data } = await this.http_client.get<Reports.Mutuals>(url, {
      params: {
        is_download,
        filters: payload.filters,
        filters_exist: payload.filters_exist,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_permissions(): Promise<Reports.Permissions> {
    const url = 'user/me/permissions';
    const { data } = await this.http_client.get<Reports.Permissions>(url);

    return data;
  }
}

export const default_date = (): Reports.RepairsPayload => ({
  month: 1,
  year: new Date().getFullYear().toString(),
});

export const default_repair_report = (): Reports.RepairsPayload => ({
  month: 0,
  year: '',
  organization_id: 0,
});

export const default_orders_reports_filters = (): Reports.OrdersReportsFilters => ({
  date: [],
  organization_ids: null,
  delivery_types: null,
  delivery_address_ids: null,
  contracts: null,
  warehouses_ids: null,
  cancel_reasons_ids: null,
  order_numbers: null,
  type: ReportOrderTypes.SHIPPED,
});

export const default_mutuals_reports_filters = (): Reports.MutualsReportsFilters => ({
  date: null,
  organization_ids: null,
  external_organizations: null,
  contracts: null,
  is_overdue_debt: false,
});
